// Two locales, no framework. Every visible string lives here (CLAUDE.md §4).
export type Locale = 'ar' | 'en';

const AR = {
  title: 'احجز مباشرة',
  loading: 'جارٍ التحميل…',
  notFound: 'لم نجد هذا الفندق.',
  arrival: 'الوصول',
  departure: 'المغادرة',
  adults: 'بالغون',
  children: 'أطفال',
  nights: 'ليالٍ',
  search: 'عرض الغرف',
  roomTypes: 'الغرف المتاحة',
  instant: 'تأكيد فوري',
  requestOnly: 'طلب حجز',
  unavailable: 'غير متاح',
  perNight: 'لليلة',
  total: 'الإجمالي',
  name: 'الاسم الكامل',
  phone: 'رقم الهاتف',
  email: 'البريد الإلكتروني (اختياري)',
  notes: 'ملاحظات للفندق (اختياري)',
  book: 'احجز الآن',
  request: 'أرسل طلب الحجز',
  confirmedTitle: 'تم تأكيد حجزك',
  requestedTitle: 'وصل طلبك إلى الفندق',
  requestedHint: 'سيرد الفندق خلال ساعة في أوقات العمل (أو صباح الغد). ستصلك رسالة عند الرد.',
  confirmation: 'رقم التأكيد',
  hotelConfirmation: 'رقم الفندق',
  whatsapp: 'تواصل مع الفندق عبر واتساب',
  call: 'اتصل بالفندق',
  error: 'تعذّر إتمام العملية. حاول مرة أخرى.',
  holdExpired: 'انتهت مهلة الحجز، ابدأ من جديد.',
  soldOut: 'لم تعد الغرفة متاحة لهذه الليالي.',
  offlineHint: 'الفندق غير متصل الآن؛ الحجوزات تُرسل كطلبات ويؤكدها الفندق.',
  lang: 'English',
  back: 'رجوع',
  powered: 'يعمل بنظام Syrova',
} as const;

const EN: Record<keyof typeof AR, string> = {
  title: 'Book direct',
  loading: 'Loading…',
  notFound: 'Hotel not found.',
  arrival: 'Arrival',
  departure: 'Departure',
  adults: 'Adults',
  children: 'Children',
  nights: 'nights',
  search: 'Show rooms',
  roomTypes: 'Available rooms',
  instant: 'Instant confirmation',
  requestOnly: 'On request',
  unavailable: 'Not available',
  perNight: 'per night',
  total: 'Total',
  name: 'Full name',
  phone: 'Phone number',
  email: 'Email (optional)',
  notes: 'Notes for the hotel (optional)',
  book: 'Book now',
  request: 'Send booking request',
  confirmedTitle: 'Your booking is confirmed',
  requestedTitle: 'Your request reached the hotel',
  requestedHint:
    'The hotel answers within an hour in working hours (or tomorrow morning). You will be notified.',
  confirmation: 'Confirmation number',
  hotelConfirmation: 'Hotel reference',
  whatsapp: 'Message the hotel on WhatsApp',
  call: 'Call the hotel',
  error: 'Something went wrong. Please try again.',
  holdExpired: 'The hold expired, please start again.',
  soldOut: 'This room is no longer available for these nights.',
  offlineHint: 'The hotel is offline right now; bookings are sent as requests the hotel confirms.',
  lang: 'العربية',
  back: 'Back',
  powered: 'Powered by Syrova',
};

export function t(locale: Locale, key: keyof typeof AR): string {
  return locale === 'ar' ? AR[key] : EN[key];
}
